import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'color-status-indicator',
    template: `
        <div
            class="status-indicator-square"
            [ngClass]="statusClass"
            [style.background-color]="statusColor"
            [style.top.px]="verticalOffset"
            [style.width.px]="size"
            [style.height.px]="size"
            [style.border-radius.px]="borderRadius"
        ></div>
    `,
    styles: [
        `
            .status-indicator-square {
                position: relative;
                display: inline-block;
                margin-right: 3px;
            }
        `
    ],
    imports: [NgClass]
})
export class ColorStatusIndicatorComponent {
    @Input() public statusColor = '';
    @Input() public statusClass = '';
    @Input() public verticalOffset = -1;
    @Input() public size = 8;
    @Input() public borderRadius = 0;
}
